import React from 'react';

import TeamCard from './TeamCard';
import {
  COLORS,
  COMMENT_TEAM,
  CURRENT_TEMPLATE_NAME,
} from '../../../../utils/const';
import SectionHeader from '../../../../components/SectionHeader';
import PortfolioCommentIcon from '../../../../components/PortfolioCommentIcon';

const { lightBlack } = COLORS;

const TeamCurrent = ({
  data: { description },
  locales,
  locales: { portfolio },
  collection,
  addPortfolioTeammate,
  updateSectionField,
  borderColorName,
  isFirstColorPallete = false,
  disabled = false,
}) => {
  return (
    <div className="team-current section relative">
      <PortfolioCommentIcon title={COMMENT_TEAM} />
      <SectionHeader
        templateName={CURRENT_TEMPLATE_NAME}
        title={portfolio.team.sectionTitle}
        description={description}
        onChange={(e) =>
          updateSectionField({
            sectionName: 'team',
            field: 'description',
            name: 'teamDescription',
            value: e.target.value,
          })
        }
        portfolio={portfolio}
        style={{ color: !isFirstColorPallete && lightBlack }}
        disabled={disabled}
      />

      <div className="team-current-cards">
        {collection.map((teammate, i) => (
          <TeamCard
            locales={locales}
            teammate={teammate}
            index={i}
            key={teammate.id}
            disabled={disabled}
            isFirstColorPallete={isFirstColorPallete}
            borderColorName={borderColorName}
          />
        ))}

        {!disabled && (
          <div className="add-team-card__wrapper custom-font-body">
            <div className="add-team-card">
              <div className="add-team-card-hover">
                <div className="center-block" onClick={addPortfolioTeammate}>
                  <i className="icon-Add" />
                  {portfolio.team.addNewTeamMember}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamCurrent;
